'use es6';

export function createKeyboardShortcut(action, ...keyTesters) {
  return function (keys) {
    if (keyTesters.find(tester => tester.testKeys(keys))) {
      action();
    }
  };
}